import { render, staticRenderFns } from "./TagSearcher.vue?vue&type=template&id=6ca2b296&"
import script from "./TagSearcher.vue?vue&type=script&lang=js&"
export * from "./TagSearcher.vue?vue&type=script&lang=js&"
import style0 from "./TagSearcher.vue?vue&type=style&index=0&id=6ca2b296&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports